import { useState, useEffect } from 'react';

/**
 * Custom hook that determines if the width is at or below a specified width.
 * Triggers a page reload if the user switches between mobile and desktop widths.
 * @param {number} maxWidth - The maximum width to consider as mobile, by default is 1023.
 * @param {boolean} automatic_reload - Whether to automatically reload the page on width change.
 * @returns {boolean} - True if the viewport width is at or below the specified maxWidth.
 */
export default function useIsMobile(maxWidth = 1023, automatic_reload = true) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);

    useEffect(() => {
        function handleResize() {
            const isCurrentlyMobile = window.innerWidth <= maxWidth;
            if (automatic_reload && isCurrentlyMobile !== isMobile) {
                window.location.reload();
            } else {
                setIsMobile(isCurrentlyMobile);
            }
        };

        window.addEventListener('resize', handleResize);

        //  unmount
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobile, maxWidth, automatic_reload]); // Depend on isMobile AND maxWidth to avoid unnecessary reloads

    return isMobile;
};